export default __webpack_public_path__ + "static/player-a8a9f20460bf5ddd22dd73eb3c2da977.png";